import React from 'react';
import { StyledInput } from './styles/Input.styles';
import { ObjectWrapper } from './styles/Common.styles';

const InputControl = ({ control, renderMode }) => (
  <ObjectWrapper>
    <StyledInput
      type={control.inputType}
      styleProps={control.attributes}
      defaultValue={control.defaultValue}
      placeholder={control.placeholder}
      height={control.height}
      renderMode={renderMode}
      readOnly
    />
  </ObjectWrapper>
);

export default InputControl;